import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import PrivateRoutes from './utils/PrivateRoutes';
import AuthProvider from './component/Login/AuthContext';
import InactivityHandler from './component/Login/InactivityHandler';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReportProvider } from './component/Reports/ReportContext';
import { ReplyProvider } from './component/Reports/ReplyContext';
import IrivsLogo from './component/image/i.png';
import DashboardRouter from './component/Others/DashboardRouter';

// Eagerly loaded (auth-critical)
import Login from './component/Login/Login';
import ForgotPassword from './component/Login/ForgotPassword';
import ResetPassword from './component/Login/ResetPassword.js';

// Lazy loaded
const Hub = lazy(() => import('./component/Others/Hub'));
const Compo = lazy(() => import('./component/Others/Compo'));
const Dark = lazy(() => import('./component/Others/Dark'));
const ResidentForm = lazy(() => import('./component/Residence/ResidentForm'));
const AllResidents = lazy(() => import('./component/Residence/AllResidents'));
const PaymentsInfo = lazy(() => import('./component/Payments/PaymentsInfo'));
const PaymentCompliance = lazy(() => import('./component/Payments/PaymentCompliance'));
const ViewReports = lazy(() => import('./component/Reports/ViewReports'));
const PendingiReports = lazy(() => import('./component/Reports/PendingiReports'));
const Navigation = lazy(() => import('./component/Others/Navigation'));
const SingleResidentProfile = lazy(() => import('./component/Residence/SingleResidentProfile'));
const Logout = lazy(() => import('./component/Login/Logout'));
const GenerateReport = lazy(() => import('./component/Reports/GenerateReport'));
const ReportDetails = lazy(() => import('./component/Reports/ReportDetails'));
const Allnotifications = lazy(() => import('./component/Others/Allnotifications'));
const SearchForm = lazy(() => import('./component/SearchForm'));
const SearchResults = lazy(() => import('./component/SearchResults'));
const LineChart = lazy(() => import('./component/Others/LineChart'));
const Emergency = lazy(() => import('./component/Emergency/Emergency'));
const AllEmergency = lazy(() => import('./component/Emergency/AllEmergency'));
const Workers = lazy(() => import('./component/Employees/Workers.js'));
const WorkersList = lazy(() => import('./component/Employees/WorkersList'));
const UserEmergency = lazy(() => import('./component/Users/UserEmergency'));
const Hamburger = lazy(() => import('./component/Hamburgers/Hamburger'));
const Hamburger2 = lazy(() => import('./component/Hamburgers/Hamburger2'));
const Hamburger3 = lazy(() => import('./component/Hamburgers/Hamburger3'));
const PaymentsDetails = lazy(() => import('./component/Payments/PaymentsDetails'));
const Footer = lazy(() => import('./component/Others/Footer'));
const Config = lazy(() => import('./component/Others/Config'));
const ViewAllArtisan = lazy(() => import('./component/Artisan/ViewAllArtisan'));
const AddArtisan = lazy(() => import('./component/Artisan/AddArtisan'));
const Artisans = lazy(() => import('./component/Users/Artisans'));
const Dashboard = lazy(() => import('./component/Users/Dashboard'));
const Left = lazy(() => import('./component/Users/Left'));
const SendReport = lazy(() => import('./component/Users/SendReport'));
const Navigations = lazy(() => import('./component/Users/Navigations'));
const ReportHistory = lazy(() => import('./component/Users/ReportHistory'));
const SuperAdminPage = lazy(() => import('./component/SuperAdmin/SuperAdminPage'));
const AdminSideBar = lazy(() => import('./component/SuperAdmin/AdminSideBar'));
const UpdateModal = lazy(() => import('./component/SuperAdmin/UpdateModal'));
const AdminDashboard = lazy(() => import('./component/SuperAdmin/AdminDashboard'));
const CreateEstate = lazy(() => import('./component/SuperAdmin/CreateEstate'));
const ViewEstate = lazy(() => import('./component/SuperAdmin/ViewEstate'));
const Navigationz = lazy(() => import('./component/SuperAdmin/Navigationz'));
const Landingpage = lazy(() => import('./component/Profile/Landingpage'));
const Settings = lazy(() => import('./component/Setting/Settings'));
const Qrscanner = lazy(() => import('./component/Qrscanner'));
const Household = lazy(() => import('./component/Users/Household'));
const Paymentshistory = lazy(() => import('./component/Users/Paymentshistory'));
const Activebutton = lazy(() => import('./component/Profile/Activebutton'));
const InactiveButton = lazy(() => import('./component/Profile/InactiveButton'));
const Notifications = lazy(() => import('./component/Others/Notifications'));
const Archives = lazy(() => import('./component/Others/Archives'));
const GenerateCustom = lazy(() => import('./component/Residence/GenerateCustom'));
const UserNotification = lazy(() => import('./component/Users/userNotification'));
const HelpFAQ = lazy(() => import('./component/Users/HelpFAQ'));
const PaidHouses = lazy(() => import('./component/Payments/PaidHouses.js'));
const Services = lazy(() => import('./component/Payments/Services.js'));
const Ecommerce = lazy(() => import('./component/Ecommerce/Ecommerce.js'));
const VendorDashboard = lazy(() => import('./component/Ecommerce/VendorDashboard'));
const EcommerceMarketplace = lazy(() => import('./component/Ecommerce/EcommerceMarketplace'));
const AdminPaymentApproval = lazy(() => import('./component/Ecommerce/AdminPaymentApproval'));
const SecurityDashboard = lazy(() => import('./component/Security/SecurityDashboard'));
const CreateSecurity = lazy(() => import('./component/Others/CreateSecurity'));
const AdminVisitors = lazy(() => import('./component/Others/AdminVisitors'));


function App() {
  return (
    <ReplyProvider>
      <ReportProvider>
        <AuthProvider>
          <div className='App'>
            <Router>
              <InactivityHandler />
              <ToastContainer />
              <Suspense fallback={
                <div style={{
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  minHeight: '100vh', background: '#f5f7fa', gap: 20,
                }}>
                  <img
                    src={IrivsLogo}
                    alt='Irivs'
                    style={{
                      width: 120,
                      animation: 'irivsPulse 1.2s ease-in-out infinite',
                    }}
                  />
                  <style>{`
                    @keyframes irivsPulse {
                      0%, 100% { opacity: 1; transform: scale(1); }
                      50% { opacity: 0.5; transform: scale(0.92); }
                    }
                  `}</style>
                </div>
              }>
              <Routes>
                <Route element={<PrivateRoutes />}>
                  <Route path='/dashboard' element={<DashboardRouter />} />
                  <Route path='/user-dashboard' element={<Dashboard />} />
                  <Route path='/security-dashboard' element={<SecurityDashboard />} />
                  
                  <Route path='/Hub' element={<Hub />} />
                  <Route path='/settings' element={<Settings />} />
                  <Route path='/scanner' element={<Qrscanner />} />
                  <Route path='/landingpage/:usersId' element={<Landingpage />} />
                  <Route path='/Compo' element={<Compo />} />
                  <Route path='/residence/:usersId/:identificationCode' element={<SingleResidentProfile />} />
                  <Route path='/servicecharge' element={<Services/>}/>
                  <Route path='/Notifications/:user_id' element={<UserNotification />} />
                  <Route path='/dark' element={<Dark />} />
                  <Route path='/nafveradues' element={<PaidHouses/>} />
                  <Route path='/payments' element={<PaymentsDetails />} />
                  <Route path='/compliance' element={<PaymentCompliance />} />
                  <Route path='/paymentsInfo' element={<PaymentsInfo />} />
                  <Route path='/navigation' element={<Navigation />} />
                  <Route path='/viewReports' element={<ViewReports />} />
                  <Route path='/pending' element={<PendingiReports />} />
                  <Route path='/ResidentForm' element={<ResidentForm />} />
                  <Route path='/allResidents' element={<AllResidents />} />
                  <Route path='/custom' element={<GenerateCustom />} />
                  <Route path='/generate' element={<GenerateReport />} />
                  <Route path='/logout' element={<Logout />} />
                  <Route path='/ReportDetails/:ireportId' element={<ReportDetails />} />
                  <Route path='/searchform' element={<SearchForm />} />
                  <Route path='/searchresult' element={<SearchResults />} />
                  <Route path='/linechart' element={<LineChart />} />
                  <Route path='/emergency' element={<Emergency />} />
                  <Route path='/allemergency' element={<AllEmergency />} />
                  <Route path='/workers' element={<Workers />} />
                  <Route path='/workerslist' element={<WorkersList />} />
                  <Route path='/create-security' element={<CreateSecurity />} />
                  <Route path='/view-security' element={<CreateSecurity />} />
                  <Route path='/admin-visitors' element={<AdminVisitors />} />
                  <Route path='/helpline' element={<UserEmergency />} />
                  <Route path='/hamburger' element={<Hamburger />} />
                  <Route path='/ham' element={<Hamburger2 />} />
                  <Route path='/hamm' element={<Hamburger3 />} />
                  <Route path='/Payments/:paymentsId' element={<PaymentsDetails />} />
                  <Route path='/footer' element={<Footer />} />
                  <Route path='/config' element={<Config />} />
                  <Route path='/addartisan' element={<AddArtisan />} />
                  <Route path='/viewall' element={<ViewAllArtisan />} />
                  <Route path='/artisans' element={<Artisans />} />
                  <Route path='/left' element={<Left />} />
                  <Route path='/ireport' element={<SendReport />} />
                  <Route path='/navigations' element={<Navigations />} />
                  <Route path='/history' element={<ReportHistory />} />
                  <Route path='/superAdmin' element={<SuperAdminPage />} />
                  <Route path='/adminsidebar' element={<AdminSideBar />} />
                  <Route path='/adminboard' element={<AdminDashboard />} />
                  <Route path='/createEstate' element={<CreateEstate />} />
                  <Route path='/viewEstate' element={<ViewEstate />} />
                  <Route path='/superNav' element={<Navigationz />} />
                  <Route path='/household' element={<Household />} />
                  <Route path="/app/user/payments-history" element={<Paymentshistory />} />
                  <Route path='/active' element={<Activebutton />} />
                  <Route path='/inactive' element={<InactiveButton />} />
                  <Route path='/notify' element={<Notifications />} />
                  <Route path='/archives' element={<Archives />} />
                  {/* <Route path='/reset-password' element={<PasswordPage />} /> */}
                  <Route path='/interface' element={<UpdateModal />} />
                  <Route path='/allnotifications' element={<Allnotifications />} />
                  <Route path='/Ecommerce' element={<Ecommerce/>} />
                  <Route path='/vendor-dashboard' element={<VendorDashboard />} />
                  <Route path='/marketplace' element={<EcommerceMarketplace />} />
                  <Route path='/admin/payment-approval' element={<AdminPaymentApproval />} />
                  <Route path='/help-faq' element={<HelpFAQ />} />
                </Route>
                <Route path='/' element={<Login />} />
                <Route path='/reset-password' element={<ResetPassword />} />
                <Route path='/forgot-password' element={<ForgotPassword />} />
              </Routes>
              </Suspense>
            </Router>
          </div>
        </AuthProvider>
      </ReportProvider>
    </ReplyProvider>
  );
}

export default App;
